"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityMap = exports.EntityMapDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var loader_1 = require("../elements/loader");
var entity_tooltip_1 = require("./entity-tooltip");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var map_marker_1 = require("../elements/map-marker");
var use_map_state_1 = require("../../hooks/use-map-state");
// @ts-ignore
var mapbox_gl_1 = __importDefault(require("mapbox-gl/dist/mapbox-gl"));
// @ts-ignore
var mapbox_gl_csp_worker_1 = __importDefault(require("mapbox-gl/dist/mapbox-gl-csp-worker"));
mapbox_gl_1.default.workerClass = mapbox_gl_csp_worker_1.default;
var react_map_gl_1 = require("react-map-gl");
require("mapbox-gl/dist/mapbox-gl.css");
exports.EntityMapDefaultProps = {
  loading: true,
  center: [-10, 60],
  zoom: 2,
  height: '600px',
  width: '100%'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: fixed; /* Stops weird scrolling when clicking map */\n    z-index: 50;\n\n    ", "\n  "], ["\n    position: fixed; /* Stops weird scrolling when clicking map */\n    z-index: 50;\n\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", ";\n      width: ", ";\n    "], ["\n      height: ", ";\n      width: ", ";\n    "])), props._height, props._width);
  })
});
var LoadingStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    z-index: 300;\n    left: 0;\n    background: rgba(0, 0, 0, 0.3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  "], ["\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    z-index: 300;\n    left: 0;\n    background: rgba(0, 0, 0, 0.3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  "])))
});
var MarkerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n    font-family: ", ";\n    width: 250px;\n  "], ["\n    font-size: ", ";\n    font-family: ", ";\n    width: 250px;\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.FONT('sans'))
});
var TooltipStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Marker: (0, styled_components_1.default)(map_marker_1.MapMarker)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), MarkerStyles),
  Loading: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), LoadingStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  Tooltip: (0, styled_components_1.default)(entity_tooltip_1.EntityTooltip)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), TooltipStyles)
};
var EntityMap = function (props) {
  var className = props.className,
    items = props.items,
    loading = props.loading,
    center = props.center,
    zoom = props.zoom,
    height = props.height,
    width = props.width;
  var defn = items && items.length && (0, use_entity_definition_1.useEntityDefinition)(items[0]);
  var Tooltip = defn && defn.components.tooltip || props.tooltip || entity_tooltip_1.EntityTooltip;
  var _a = (0, use_map_state_1.useMapUtils)(),
    deselect = _a.deselect,
    toggleSelectedEntity = _a.toggleSelectedEntity,
    init = _a.init,
    hideOnClick = _a.hideOnClick;
  var _b = __read((0, use_map_state_1.useMapState)(), 3),
    mapState = _b[0],
    setMapState = _b[1],
    patchMapState = _b[2];
  var isInitialized = mapState.isInitialized,
    selectedEntity = mapState.selectedEntity,
    isVisible = mapState.isVisible;
  var loadingElement = react_1.default.createElement(My.Loading, null, react_1.default.createElement(My.Loader, {
    spinnerColor: "light",
    spinnerSize: 24,
    inverted: true
  }, "Please wait"));
  if (typeof window === 'undefined') {
    return react_1.default.createElement(My.Container, {
      _width: width,
      _height: height,
      className: className
    }, loadingElement);
  }
  var itemsWithMarkers = items.filter(function (result) {
    return !!result.latitude && !!result.longitude;
  });
  return react_1.default.createElement(My.Container, {
    _width: width,
    _height: height,
    className: className
  }, loading && loadingElement, react_1.default.createElement(react_map_gl_1.Map, __assign({}, mapState, {
    mapboxAccessToken: process.env.MAPBOX_API_KEY,
    mapStyle: process.env.MAPBOX_STYLE_URL || 'mapbox://styles/mapbox/streets-v11',
    mapLib: mapbox_gl_1.default,
    reuseMaps: true,
    doubleClickZoom: false,
    onMove: function (evt) {
      return patchMapState(evt.viewState);
    },
    style: {
      width: width,
      height: height
    }
  }), itemsWithMarkers.map(function (entity) {
    // note the taxonomies have been remapped for other purposes (hence vairable aliasing). Need a better solution for this eventually 
    var id = entity.id,
      latitude = entity.latitude,
      longitude = entity.longitude;
    var isSelected = selectedEntity && selectedEntity.id === entity.id;
    var coordinates = [latitude, longitude];
    return react_1.default.createElement(My.Marker, {
      style: {
        opacity: isSelected ? 1.0 : !!selectedEntity ? 0.8 : 1.0,
        zIndex: isSelected ? 200 : 100
      },
      isSelected: isSelected,
      onClick: function () {
        toggleSelectedEntity(entity);
      },
      onClose: deselect,
      key: entity.id,
      longitude: entity.longitude,
      latitude: entity.latitude,
      zoom: mapState.zoom
    }, isSelected && react_1.default.createElement(My.Tooltip, {
      entity: selectedEntity
    }));
  })));
};
exports.EntityMap = EntityMap;
exports.EntityMap.defaultProps = exports.EntityMapDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;